import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export const variantGridColumnsVisualizer = () => [
    {
        field: 'sequence',
        headerName: 'ID',
        width: 95,
        sort: 'asc',
        tooltipField: 'variant',
        suppressMenu: true,
        menuTabs: []
    },
    {
        field: 'variant',
        headerName: 'Variant',
        hide: true,
    },
    {
        field: 'tasks',
        headerName: apiProvider.getEntityUpper() + 's',
        sort: 'desc',
        filter: 'agNumberColumnFilter',
        width: 120,
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
    },
    {
        field: 'events',
        headerName: 'Events',
        width: 120,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
        hide: true,
    },
    {
        field: 'steps',
        headerName: 'Steps',
        width: 120,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
        hide: true,
    },
    {
        field: 'activities',
        headerName: 'Activities',
        width: 120,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
        hide: true,
    },
    {
        field: 'perc_total_tasks',
        headerName: '% Work Items',
        width: 120,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatPercentage({ perc: value, decimals: 1  }),
    },
    {
        field: 'avg_duration',
        headerName: 'Avg Duration',
        width: 130,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
            hide: false,
        },
    {
        field: 'total_duration',
        headerName: 'Total Duration',
        width: 130,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
            hide: false,
    },        
    {
        field: 'std_deviation',
        headerName: 'Std Deviation',
        width: 130,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: false,
    },
    {
        field: 'loop',
        headerName: 'Loops',
        filter: true,
        width: 100,
        hide: false,
    },
    {
        field: 'loops',
        headerName: '# Loops',
        filter: true,
        hide: true,
    },
    {
        field: 'age',
        headerName: 'Age (Days)',
        hide: true,
    },
    {
        field: 'min_duration',
        headerName: 'Min Duration',
        width: 120,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: true,
    },
    {
        field: 'max_duration',
        headerName: 'Max Duration',
        width: 120,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: true,
    },
    {
        field: 'perc_total_events',
        headerName: '% Total Events',
        width: 120,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatPercentage({ perc: value , decimals: 1 }),
        hide: true,
    },
    {
        field: 'avg_duration_days',
        headerName: 'Avg Duration (days)',
        type: 'rightAligned',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'std_deviation_days',
        headerName: 'Std Deviation (days)',
        type: 'rightAligned',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'avg_duration_hrs',
        headerName: 'Avg Duration (hours)',
        type: 'rightAligned',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'std_deviation_hrs',
        headerName: 'Std Deviation (hours)',
        type: 'rightAligned',
        filter: 'agNumberColumnFilter',
        hide: true,
    },

    {
        field: 'variant_id',
        headerName: 'ID',
        hide: true,
    },
    {
        field: 'selected',
        headerName: 'Selected',
        hide: true,
    },
  
];
